import { render, staticRenderFns } from "./PropSettings.vue?vue&type=template&id=0a5c4583&scoped=true"
import script from "./PropSettings.vue?vue&type=script&lang=ts"
export * from "./PropSettings.vue?vue&type=script&lang=ts"
import style0 from "./PropSettings.vue?vue&type=style&index=0&id=0a5c4583&prod&lang=scss&scoped=true"
import style1 from "./PropSettings.vue?vue&type=style&index=1&id=0a5c4583&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5c4583",
  null
  
)

export default component.exports